import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import AttUserDetail from "./UserDetails/AttUserDetail";
import AttUserSchedule from "./UserDetails/AttUserSchedule";
import { useParams, useSearchParams } from "react-router-dom";
import AttUserFiles from "./UserDetails/AttUserFiles";

export default function UpdateAttUser({
  showModal,
  isAdd = false,
  userData,
  refreshFunc,
}) {
  /*   All States
   ********************************************* */

  const [formData, setFormData] = useState({});
  const [activeTab, setActiveTab] = useState("userInfo");

  /*   All Functions
   ********************************************* */
  const dispatch = useDispatch();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    let deviceId = params?.deviceId;

    if (!deviceId) {
      dispatch(
        setNotification({
          message: "Please select a device",
          type: "error",
        })
      );
      loadingOff();
      return;
    }

    try {
      loadingOn();
      const userFormData = new FormData();
      userFormData.append(
        "formData",
        JSON.stringify({
          ...formData,
          deviceId: deviceId,
          weeklySchedule: JSON.stringify(formData?.weeklySchedule),
          rules: JSON.stringify(formData?.rules),
        })
      );

      userFormData.append("id", userData?.id);
      userFormData.append("userId", userData?.userId);

      userFormData.append("file", formData.file);

      const { data } = await API.patch("/device-user-update/", userFormData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });

      if (data.success) {
        await refreshFunc(deviceId);
        dispatch(
          setNotification({
            message: data.message,
            type: "success",
          })
        );
        showModal(false);
        loadingOff();
        return;
      }
      if (!data.success) {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
        loadingOff();
        return;
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    let deviceId = searchParams.get("deviceId");

    if (!deviceId) {
      dispatch(
        setNotification({
          message: "Please select a device",
          type: "error",
        })
      );
      loadingOff();
      return;
    }

    try {
      loadingOn();
      const userFormData = new FormData();
      userFormData.append(
        "formData",
        JSON.stringify({
          ...formData,
          deviceId: deviceId,
          weeklySchedule: JSON.stringify(formData?.weeklySchedule),
          rules: JSON.stringify(formData?.rules),
        })
      );
      userFormData.append("file", formData.file);

      // userFormData.append(
      //   "folder",
      //   `kms/attendance/${user?.companyId}/${params?.deviceId}/${userData?.id}/profilePic`
      // );

      const { data } = await API.post("/device-user-add/", userFormData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });
      if (data.success) {
        await refreshFunc(deviceId);
        dispatch(
          setNotification({
            message: data.message,
            type: "success",
          })
        );
        showModal(false);
        loadingOff();
        return;
      }
      if (!data.success) {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
        loadingOff();
        return;
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setFormData({
      ...userData,
      weeklySchedule: userData?.weeklySchedule
        ? JSON.parse(userData?.weeklySchedule)
        : {
            Monday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Tuesday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Wednesday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Thursday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Friday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Saturday: {
              inTime: "08:30",
              outTime: "17:30",
              working: true,
            },
            Sunday: {
              inTime: "",
              outTime: "",
              working: false,
            },
          },
      rules: Object.keys(userData?.rules || {}).length
        ? JSON.parse(userData?.rules)
        : {
            overTime: {
              name: "Overtime Calculation",
              description:
                "Calculate overtime after expected hours + overtimeAfterMinutes",
              isChecked: false,
            },
            lateTime: {
              name: "Late Time Calculation",
              description:
                "Only calculate late time when inTime is greater than inTimeWithRelaxationFormatted. Count late time from userInTime when inTime is less than inTimeWithRelaxationFormatted",
              isChecked: false,
            },
          },
    });
  }, [userData]);

  return (
    <div>
      {loading && <Spinner />}
      <h3 className="mb-2">Update Attendance User</h3>
      <div className="mt-3 custom-shadow-sm" style={{ width: "fit-content" }}>
        <button
          onClick={() => setActiveTab("userInfo")}
          className={`btn   ${
            activeTab === "userInfo" ? "btn-primary" : "btn-light"
          }`}
        >
          User Info
        </button>
        <button
          onClick={() => setActiveTab("schedule")}
          className={`btn ${
            activeTab === "schedule" ? "btn-primary" : "btn-light"
          }`}
        >
          Schedule
        </button>
        {!isAdd && (
          <button
            onClick={() => setActiveTab("files")}
            className={`btn ${
              activeTab === "files" ? "btn-primary" : "btn-light"
            }`}
          >
            Files
          </button>
        )}
      </div>
      <hr className="mt-2 mb-3" />

      <form onSubmit={isAdd ? handleAdd : handleUpdate}>
        {activeTab === "userInfo" && (
          <AttUserDetail
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            refreshFunc={refreshFunc}
          />
        )}
        {activeTab === "schedule" && formData?.weeklySchedule && (
          <AttUserSchedule
            isAdd={isAdd}
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
          />
        )}
        {activeTab === "files" && formData?.weeklySchedule && (
          <AttUserFiles userData={userData} />
        )}

        <div className="text-end mt-3">
          <button
            onClick={(e) => {
              showModal(false);
            }}
            type="button"
            className="btn btn-secondary me-1"
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            {isAdd ? "Add" : "Update"}
          </button>
        </div>
      </form>
    </div>
  );
}
